var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatClosed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33301 7.29199V26.667C3.33301 26.9723 3.47201 27.1873 3.75001 27.312C4.02801 27.4373 4.29201 27.375 4.54201 27.125L10 21.667H17.7083L14.083 18.042L11.458 15.375L3.33301 7.29199ZM20.4995 24.458H10V28.292C10 28.7087 10.1807 29.0973 10.542 29.458C10.9027 29.8193 11.2913 30 11.708 30L26.042 30L20.4995 24.458Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.667 32.667L28.458 24.458H31.125V10H35C35.4167 10 35.7987 10.1807 36.146 10.542C36.4933 10.9027 36.667 11.3053 36.667 11.75V32.667ZM26.625 3.33301H7.33301L14 10L16.75 12.792L19.25 15.292L22.042 18.042L24.542 20.542L25.667 21.667H26.625C27.0697 21.667 27.4653 21.4863 27.812 21.125C28.1593 20.7637 28.333 20.3747 28.333 19.958V5.04201C28.333 4.62534 28.1593 4.23634 27.812 3.87501C27.4653 3.51367 27.0697 3.33301 26.625 3.33301Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33299 7.292L2.08299 6.042C1.80566 5.764 1.66699 5.43067 1.66699 5.042C1.66699 4.65267 1.80566 4.31933 2.08299 4.042C2.36099 3.764 2.68733 3.625 3.06199 3.625C3.43733 3.625 3.76399 3.764 4.04199 4.042L35.542 35.5C35.8193 35.778 35.958 36.1043 35.958 36.479C35.958 36.8543 35.8193 37.1807 35.542 37.458C35.264 37.736 34.9307 37.875 34.542 37.875C34.1527 37.875 33.8193 37.736 33.542 37.458L26.042 30L19.375 23.333L16.583 20.542L14.083 18.042L11.458 15.375L3.33299 7.292Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatClosed);
export default __webpack_public_path__ + "static/media/chat-closed.1679233180d11607a71fc3b063fe6538.svg";
export { ForwardRef as ReactComponent };